import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manual_line',
  templateUrl: './manual_line.component.html',
  styleUrls: ['./manual_line.component.css']
})
export class Manual_lineComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
